import { Button, Dialog } from 'Components/Core';
import { actions } from 'Data/ReduxViewModels/Admin';
import { useDispatch } from 'react-redux';
import { IDialogDeleteParams } from '../types';

const AgsExportConfigurationDeleteDialogAdmin: React.FC<IDialogDeleteParams> = ({
  agsExportConfigurationId,
  dialogVisibleState,
  onClose,
}) => {
  const dispatch = useDispatch();
  const deleteAgsExportConfiguration = () => {
    dispatch(
      actions.deleteAgsExportConfiguration({
        elementId: agsExportConfigurationId,
      })
    );
    onClose();
  };

  const dialogButtons = [
    <Button
      primary
      onClick={() => {
        deleteAgsExportConfiguration();
      }}
    >
      Yes
    </Button>,
    <Button onClick={onClose}>No</Button>,
  ];

  return (
    <Dialog
      onClose={onClose}
      visible={dialogVisibleState}
      buttons={dialogButtons}
      title="Deleting AGS Export Configuration"
    >
      Are you sure you want to delete this Configuration?
    </Dialog>
  );
};

export { AgsExportConfigurationDeleteDialogAdmin };
